import React,{ Component } from "react";
import { connect } from "react-redux";
import { getServers, deleteServer, destroyAgentKasms } from "../../actions/actionServer";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { NotificationManager } from "react-notifications";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import { Progress } from 'reactstrap';
import moment from 'moment';
import { fuzzySearch } from "../../utils/helpers";
const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Agents",path:"/agents",isActive: true}
];

class Agents extends Component{
    constructor(props) {
        super(props);        
        this.state = {
            modal: false,
            pages: 1,
            serverId: null
        };
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.destroyKasmsConfirm = this.destroyKasmsConfirm.bind(this);
        this.deleteServerAction = this.deleteServerAction.bind(this);
        this.destroyKasmsAction = this.destroyKasmsAction.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.cancelDestroy =  this.cancelDestroy.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.handleDestroyKasmSuccess = this.handleDestroyKasmSuccess.bind(this);
        this.handleDestroyKasmError = this.handleDestroyKasmError.bind(this);
    }

    componentDidMount(){
        this.props.getServers();
    }

    deleteConfirm(serverId){
        this.setState({modal: !this.state.modal, serverId: serverId});
    }

    destroyKasmsConfirm(serverId){
        this.setState({destroyModal: !this.state.destroyModal, serverId: serverId});
    }

    cancelDestroy(){
        this.setState({destroyModal: !this.state.destroyModal});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    deleteServerAction(){
        this.props.deleteServer(this.state.serverId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    destroyKasmsAction(){
        this.props.destroyAgentKasms(this.state.serverId).
            then(() => this.handleDestroyKasmSuccess()).
            catch(() => this.handleDestroyKasmError());
    }

    handleDeleteSuccess(){
        const {deleteServerErrorMessage} = this.props;
        if(deleteServerErrorMessage) {
            NotificationManager.error(deleteServerErrorMessage,"Delete Agent", 3000);
            this.setState({modal: false});
        }
        else{
            NotificationManager.success("Successfully Deleted Agent","Delete Agent", 3000);
            this.setState({modal: false});
            this.props.getServers();
        }
    }

    handleDeleteError(){
        const {deleteServerError} = this.props;
        if(deleteServerError){
            NotificationManager.error(deleteServerError,"Delete Agent", 3000);
            this.setState({modal: false});
        }
        else{
            NotificationManager.error("Failed to Delete Agent","Delete Agent", 3000);
            this.setState({modal: false});
        }
    }

    handleDestroyKasmSuccess(){
        const {destroyAgentKasmsErrorMessage} = this.props;
        if(destroyAgentKasmsErrorMessage) {
            NotificationManager.error(destroyAgentKasmsErrorMessage,"Delete Kasms", 3000);
            this.setState({destroyModal: false});
        }
        else{
            NotificationManager.success("Successfully marked Kasms for deletion","Delete Kasms", 3000);
            this.setState({destroyModal: false});
            this.props.getServers();
        }
    }

    handleDestroyKasmError(){
        const {destroyAgentKasmsError} = this.props;
        if(destroyAgentKasmsError){
            NotificationManager.error(destroyAgentKasmsError,"Destroy Kasms", 3000);
            this.setState({destroyModal: false});
        }
        else{
            NotificationManager.error("Failed to mark Kasms for deletion","Destroy Kasms", 3000);
            this.setState({destroyModal: false});
        }
    }

    render(){
        if (this.props.getServersLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const { servers } = this.props;
        const { loading } = this.state;
        const columns = [{
            Header: "Host Name",
            accessor: "hostname",
            filterMethod: fuzzySearch
        },
        {
            Header: "Agent Id",
            accessor: "server_id",
            filterMethod: fuzzySearch
        },
        {
            Header: "Enabled",
            accessor: "enabled",
            filterMethod: fuzzySearch,
            Cell: (props) => (<div> {props.original.enabled ? 'True' : 'False'}</div>)
        },
        {
            Header: "Last Reported",
            accessor: "last_reported_elapsed",
            filterable: false,
            sortable: false
        },
        {
            Header: "Status",
            accessor: "operational_status",
            filterMethod: fuzzySearch
        },
        {
            Header: "Manager",
            accessor: "manager.manager_hostname",
            filterMethod: fuzzySearch
        },
        {
            Header: "Zone",
            accessor: "manager.zone_name",
            filterMethod: fuzzySearch,
        },
        {
            Header: "Kasms",
            accessor: "kasms.length",
            filterMethod: fuzzySearch
        },
        {
            Header: "Provider",
            accessor: "provider",
            filterMethod: fuzzySearch
        },
        {
            Header: "CPU Allocation/Usage",
            filterable: false,
            accessor: "core_calculations.percentage",
            Cell: props => props.original.cpu_percent < props.value ?
                               (<Progress multi>
                                   <Progress  bar color={props.original.cpu_percent < 80 ? "success":"danger"} value={props.original.cpu_percent} />
                                   <Progress  bar color="info" value={props.value - props.original.cpu_percent} />
                               </Progress>)
                               :
                               (<Progress multi>
                                   <Progress  bar color="info" value={props.value} />
                                   <Progress  bar color={props.original.cpu_percent < 80 ? "success":"danger"} value={props.original.cpu_percent - props.value} />
                               </Progress>)
        },
        {
            Header: "Memory Allocation/usage",
            filterable: false,
            accessor: "memory_calculations.percentage",
            Cell: props => props.original.memory_stats.percent < props.value ?
                               (<Progress multi>
                                   <Progress  bar color={props.original.memory_stats.percent < 80 ? "success":"danger"} value={props.original.memory_stats.percent} />
                                   <Progress  bar color="info" value={props.value - props.original.memory_stats.percent}/>
                               </Progress>)
                               :
                               (<Progress multi>
                                   <Progress  bar color="info" value={props.value} />
                                   <Progress  bar color={props.original.memory_stats.percent < 80 ? "success":"danger"} value={props.original.memory_stats.percent - props.value}/>
                               </Progress>)
        },
        {
            Header: "Actions",
            filterable: false,
            sortable: false,
            Cell: (data) => (<div className="action-btn">
                <Link className="btn btn-success" to={{ pathname: `/viewagent/${data.original.server_id}` }}>
                    <i className="fa fa-eye" id={"TooltipComponent"}></i> </Link>
                <Link className="btn btn-warning" id={"Tooltipss"} to={{ pathname: `/updateagent/${data.original.server_id}` }}>
                    <i className="fa fa-pencil"></i> </Link>
                <button className="btn btn-danger" href="#" onClick={() => this.deleteConfirm(data.original.server_id)}>
                    <i className="fa fa-trash-o" id={"Tooltips"}></i> </button>
                <button className="btn btn-dark" href="#" onClick={() => this.destroyKasmsConfirm(data.original.server_id)}>
                    <i className="fa fa-bomb" id={"Tooltips"}></i> </button>
                <UncontrolledTooltip placement="right" target={"TooltipComponent"}> View </UncontrolledTooltip>
                <UncontrolledTooltip placement="right" target={"Tooltips"}> Delete </UncontrolledTooltip>
            </div>
            ),
        }];

        return (
            <div> 
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>Agents</strong>
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    columns={columns}
                                    data={servers}
                                    defaultSorted={[{id: "hostname"}]}
                                    loading={loading}
                                    filterable
                                    defaultPageSize={10}
                                    className="-striped -highlight site_table"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>


                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className={this.props.className}>
                    <ModalHeader toggle={this.cancelDelete}>Delete Server <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                          Confirm Delete Agent?
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.deleteServerAction} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                        <Button onClick={this.cancelDelete} size="sm" color="basic"><i className="fa fa-ban"></i> Close</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.destroyModal} toggle={this.cancelDestroy} className={this.props.className}>
                    <ModalHeader toggle={this.cancelDestroy}>Destroy Kasms <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                        Destroy Kasms?
                        <br/>
                        <br/>
                        Kasms that reside on this Agent will be marked for deletion. They will be destroyed in a few moments.
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.destroyKasmsAction} size="sm" color="danger"> <i className="fa fa-trash"></i> Destroy</Button>
                        <Button onClick={this.cancelDestroy} size="sm" color="basic"><i className="fa fa-ban"></i> Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Agents.propTypes = {
    getServers: Proptypes.func.isRequired,
    deleteServer: Proptypes.func.isRequired,
    destroyAgentKasms: Proptypes.func.isRequired,
    deleteServerError: Proptypes.func,
    destroyAgentKasmsError: Proptypes.func,
    servers: Proptypes.array,
    getServersLoading: Proptypes.bool,
    deleteServerErrorMessage: Proptypes.func,
    destroyAgentKasmsErrorMessage: Proptypes.func,
    className: Proptypes.func
};


export default connect(state => 
    ({
        servers: state.servers.servers || [],
        deleteServerErrorMessage: state.servers.deleteServerErrorMessage || null,
        destroyAgentKasmsErrorMessage: state.servers.destroyAgentKasmsErrorMessage || null,
        getServersLoading: state.servers.getServersLoading || false,
        deleteServerError: state.servers.deleteServerError || null,
        destroyAgentKasmsError: state.servers.destroyAgentKasmsError || null,

    }),
dispatch => 
    ({  
        getServers: () => dispatch(getServers()),
        deleteServer: (data) => dispatch(deleteServer(data)),
        destroyAgentKasms: (data) => dispatch(destroyAgentKasms(data))
    }))(Agents);


// WEBPACK FOOTER //
// ./src/views/Agents/Agents.js